var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FA7700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.231 31.143c-.103.135-.324.361-.637.361H2.406c-.313 0-.534-.226-.637-.361-.282-.368-.386-.906-.27-1.406C2.863 23.803 8.541 19.496 15 19.496c6.458 0 12.136 4.307 13.502 10.24.115.5.011 1.04-.27 1.407m1.682-1.751c-.734-3.19-2.615-6.085-5.297-8.154C21.91 19.15 18.494 18 15 18c-3.494 0-6.91 1.15-9.617 3.238C2.701 23.307.82 26.202.086 29.391c-.218.95-.015 1.95.544 2.68.453.59 1.1.929 1.776.929h25.188c.676 0 1.323-.339 1.776-.93.559-.728.762-1.73.544-2.678M9.485 6.779c0-2.945 2.474-5.341 5.515-5.341 3.041 0 5.515 2.396 5.515 5.34v2.443c0 2.945-2.474 5.341-5.515 5.341-3.041 0-5.515-2.396-5.515-5.34V6.778zM15 16c3.86 0 7-3.04 7-6.779V6.78C22 3.04 18.86 0 15 0S8 3.04 8 6.779V9.22C8 12.96 11.14 16 15 16z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerPerson);
export default __webpack_public_path__ + "static/media/per-person.b51fa102.svg";
export { ForwardRef as ReactComponent };